// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_user-module__container--BpNYY","picture":"nav_user-module__picture--Q-jNL","username":"nav_user-module__username--13Atl"};